/**
 * Created by pandemio on 9/20/18.
 */
class SessionManager {
    /**
     * Sets the session
     * @param token
     */
    static setSession(token)
    {
        localStorage.setItem('ul', token);
    }

    /**
     * Returns the session
     * @returns {*}
     */
    static getSession(){
        let session = null;
        if(localStorage.getItem('ul') != null)
            session = localStorage.getItem('ul');
        return session;
    }

    /**
     * Evaluates if session is active or not
     * @returns {boolean}
     */
    static evaluateSession(){
        return (SessionManager.getSession() != null && SessionManager.getSession().length > 0);
    }

    /**
     * Deletes a session
     */
    static deleteSession(){
        return localStorage.removeItem('ul');
    }
}

export default SessionManager;



// WEBPACK FOOTER //
// ./src/custom-classes/session-manager.js